import React from 'react';
import PropTypes from 'prop-types';
import { Button, Modal } from '@getro/rombo';
import { Box, Flex, Text } from 'rebass/styled-components';

export const DeleteCustomFieldModal = ({ onCloseModal, onDeleteCustomField, isLoading }) => (
  <Box data-testid="delete-custom-field-modal" onClick={(e) => e.stopPropagation()}>
    <Modal
      title="Delete custom field?"
      onCancel={onCloseModal}
      actions={
        <Flex sx={{ gap: '8px', justifyContent: 'flex-end' }}>
          <Button variant="secondary" onClick={onCloseModal}>
            Cancel
          </Button>
          <Button data-testid="delete-btn" variant="danger" onClick={onDeleteCustomField} loading={isLoading}>
            Delete forever
          </Button>
        </Flex>
      }
    >
      <Text fontSize="14px">Deleting this field will:</Text>
      <Box as="ul" pl="24px" pt="8px">
        <Box as="li">
          <Text fontSize="14px">Permanently delete this field</Text>
        </Box>
        <Box as="li">
          <Text fontSize="14px">Permanently delete all values assigned to contacts</Text>
        </Box>
      </Box>
      <Text mt="16px" fontSize="14px" fontWeight="medium">
        This action cannot be undone.
      </Text>
    </Modal>
  </Box>
);

DeleteCustomFieldModal.propTypes = {
  onCloseModal: PropTypes.func.isRequired,
  onDeleteCustomField: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
};

DeleteCustomFieldModal.defaultProps = {
  isLoading: false,
};
